import React, { Component, Fragment } from 'react';
import { Button, DatePicker } from 'antd';
import translate from 'counterpart';
import moment from 'moment';

import { notEmpty } from 'utils/ramdaAdditions';
import { momentToFormat } from 'helpers/fieldsHelpers';
import { DATE_FORMATS } from 'constants/dateFormats';
import CustomIcon from 'components/common/CustomIcon';

class RangePicker extends Component {
    getDateRange = (direction) => {
        const { value: [ datefrom, dateto ] } = this.props;
        const nextDateTo = dateto.clone()[direction](1, 'months');
        const isCurrentMonthEnd = dateto.isSame(dateto.clone().endOf('month'), 'day');

        return [
            datefrom.clone()[direction](1, 'months'),
            isCurrentMonthEnd ? nextDateTo.endOf('month') : nextDateTo,
        ];
    }

    nextDateRange = () => {
        this.props.setDateRange(this.getDateRange('add'));
    }

    prewDateRange = () => {
        this.props.setDateRange(this.getDateRange('subtract'));
    }

    render() {
        const { setDateRange, value, value: [ datefrom, dateto ], ...props } = this.props;
        const isDate = notEmpty(datefrom) && notEmpty(dateto);
        const isSame = isDate && datefrom.isSame(dateto, 'month');

        const format = isDate ? (
            `[${ momentToFormat(datefrom, isSame && DATE_FORMATS.dayFormat) } - ${ momentToFormat(dateto, DATE_FORMATS.dayMonthYearFormat) }]`
        ) : DATE_FORMATS.format;

        const ranges = {
            [translate('rangePicker.today')]: [moment(), moment()],
            [translate('rangePicker.thisMonth')]: [moment().startOf('month'), moment().endOf('month')]
        };

        return (
            <Fragment>
                <Button disabled={!isDate} onClick={this.prewDateRange} ghost size="small" icon={<CustomIcon type='angle-left' />} />
                <DatePicker.RangePicker
                    format={format}
                    onChange={setDateRange}
                    ranges={ranges}
                    value={value}
                    placeholder={[translate('placeholders.chooseInterval')]}
                    {...props}
                 />
                <Button disabled={!isDate} onClick={this.nextDateRange} ghost size="small" icon={<CustomIcon type='angle-righ' />} />
            </Fragment>
        );
    }
}

export default RangePicker;

